import { Component, Inject, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaskApplierService, MaskPipe } from 'ngx-mask';
import { Subscription } from 'rxjs';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { Document } from '../../models/document';
import { AppLoadingService } from '../../services/apploading.service';
import { GeneralService } from '../../services/general.service';
import { AbstractForm } from '../../utils/abstract-form';
import { AuthorizationPreviewComponent } from '../authorization-preview/authorization-preview.component';
import { ReasonComponent } from '../reason/reason.component';
import { SignaturePadComponent } from '../signature-pad/signature-pad.component';
import { API } from 'src/app/configs';
import { HttpService } from 'src/app/core/http/http.service';
import { SignatureService } from '../../services/signature.service';
import { RequestAuthorizationService } from '../../services/request-authorization.service';
import { Address } from '../../models/address';
import { City } from '../../models/city';
import { CurrencyCustomPipe } from 'src/app/core/pipe/pipe-currencyCustom';
import { AddressComponent } from '../address/address.component';

declare var $;

@Component({
  selector: 'dialog-authorization',
  templateUrl: 'dialog-authorization.component.html',
  styleUrls: ['./dialog-authorization.component.scss']
})
export class DialogAuthorizationComponent extends AbstractForm implements OnInit, OnDestroy {

  business:any = [ ];

  states: any = [];

  sended = false;

  businessSelected = -1;
  businessSelectedData:any= {};

  formDisabled = false;

  personsList:any = [];

  companies: any = {list : []};
  
  init = false;

  buttonsDisabled = false;

  modalId = null;

  addressSelected:Address = new Address();
  addressValid = false;

  readonly = false;
  addressReadonly = false;
  documentReadonly = false;

  personData: any = [];

  view = false;

  @ViewChild('contentEl', { static: true, read: ViewContainerRef }) contentEl: ViewContainerRef;
  
  expirations: any = [
    { id: 0,
      text: 'Indeterminado' 
    },
    { id: 3,
      text: '3 meses' 
    },
    { id: 6,
      text: '6 meses' 
    },
    { id: 12,
      text: '12 meses' 
    },
    { id: 18,
      text: '18 meses' 
    },
    { id: 24,
      text: '24 meses' 
    }
  ];


  expirationSel = this.expirations[1];
  comissionDefault = '5,00';
  comissionSel = '5,00';

  addressForm: AbstractForm|any = null;

  addressColSize = {
    'zipcode' : 'col-6',
    'state' : 'col-6',
    'cityName' : 'col-6',
    'district' : 'col-6',
    'street' : 'col-8',
    'number' : 'col-4',
    'complement' : 'col-12',
  };

  protected personDataSubscription: Subscription;
  protected companiesSubscription: Subscription;
  protected filesSubscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialog: MatDialog,
    protected gs: GeneralService,
    protected signatureService : SignatureService,
    protected ms : MaskApplierService,
    protected als: AppLoadingService,
    protected httpService: HttpService,
    protected authorizationService: RequestAuthorizationService,
    protected formBuilder: FormBuilder,
    logger: LoggerService,
  ) { 

    super(formBuilder, logger, true);


    if(this.data?.data){
      this.modalId = this.data.modalId;
      this.data = this.data?.data;
    }

    this.personDataSubscription = this.gs.generalData$.subscribe((result) => {
      if (!!result?.person?.length) {
          this.states = result?.states;


          this.personData = result?.person[0];


          let city = new City();
          city.id = this.personData.address_city_id;
          city.name = this.personData.address_city_name;
          city.state = this.personData.address_state_id;
  
          this.personData.address = new Address(
              '',
              this.personData.address_zipcode,
              city,
              this.personData.address_street,
              this.personData.address_number,
              this.personData.address_complement,
              this.personData.address_district,
              this.personData.address_latitude,
              this.personData.address_longitude,
              0
          );

          this.setControlValue('creci_state_id', this.personData?.creci_state_id || '1');

          this.business.push({
              company_person_id : this.personData.person_id,
              avatarFile : this.gs.getAvatarFile(this.personData.avatar),
              name : this.personData.person_name,
              type : '1',
              document : this.personData.document,
              creci : this.personData.creci_code,
              creci_state_id : this.personData.creci_state_id,
              address : this.personData?.address || new Address
          });                
      }
    });

    this.companiesSubscription = this.gs.companies$.subscribe(result => {
      if(!this.companies.list.length){
          this.companies = result;
          this.companies.list.filter(item => ['6'].indexOf(item.company_perfil_id) > -1).map(item => {
              
              item.type = '2';
               
              let city = new City();
                  city.id = item.address_city_id;
                  city.name = item.address_city;
                  city.state = item.address_state_id;
          
              item.address = new Address(
                  '',
                  item.address_zipcode,
                  city,
                  item.address_street,
                  item.address_number,
                  item.address_complement,
                  item.address_district,
                  0,
                  0,
                  0
              );

              this.personsList.push(item.company_person_id);

              this.business.push(item);
          });
      }
    });
  }

  imgDidLoad(event){
    this.gs.imgDidLoad(event);
  }

  closeModal(result = null){
    this.dialog.getDialogById(this.modalId).close(result);
  }

  buildFormGroup(): FormGroup {
    
    return this.formBuilder.group({
      person_id: [0],
      type: ['2'],
      name: ['', [Validators.required, Validators.minLength(7)]],
      address: [''],
      document: ['', [Validators.required, Validators.minLength(14), Document.validate('cnpj')]],
      creci: ['', [Validators.required, Validators.minLength(3)]],
      creci_state_id: ['1', [Validators.required]],
      expiration: [this.data?.authorization? this.expirations[1] : null, []],
      comission: [this.data?.authorization? this.comissionSel : null, []]
    });

  }

  updateControls() { }
  updateObject(): any { }

    
  receiveEvent(form: AbstractForm|any): void {
    if(form instanceof AddressComponent){

        this.addressForm = form;

    } else if(form=='dirty') {
        this.formGroup.markAsDirty();
    }
  }

  async ngOnInit() {

    await this.setDefault();
    this.init=true;
  }

  ngOnDestroy(){
    this.personDataSubscription?.unsubscribe();
    this.filesSubscription?.unsubscribe();
  }

  async setDefault(){
    if(this.data?.authorization){
        let data:any  = this.data?.authorization;

        this.view = data.status == '-1';

        this.setControlValue('comission',data?.ad_commission || '5.0000');
        let currencyCustom = new CurrencyCustomPipe();

        this.comissionSel = currencyCustom.transform(data?.ad_commission || '5.0000', false, 'pt');

        data.payload = typeof data.payload === 'string'? JSON.parse(data.payload) : data.payload;
        this.selectBusiness(data.payload);
    } else 
        await this.loadListStatus();
  }


  openProfile(ev, public_idtext){
    this.gs.openProfile(ev, public_idtext); 
  }

  async loadListStatus(){

    await this.als.setLoaded(false, 'authorizationListStatus');

    return await this.httpService.post<any>(API.person.general.authorization.listStatus, {
            owner_person_ids: this.personsList,
            ...(this.data?.adId? {ad_id : this.data.adId} : {}),
            ad_owner_public_idtext : this.data?.owner?.publicIdText || this.data?.public_idtext
        })
          .then(result => {
            result.map(item => {
                this.business = this.business.map(itemb => {
                    if(item.person_id == itemb.company_person_id){
                        item.pending_requests = parseInt(item.pending_requests);
                        item.valid_authorizations = parseInt(item.valid_authorizations);
                        itemb = {...itemb, ...item};
                    }
                    return itemb;
                });
            });
          })
          .catch((err) => this.gs.error(err))
          .finally(async () => {
            await this.als.setLoaded(true, 'authorizationListStatus');
        });
  }


  previewAuthorization(ev, authorizeData = this.getFormValues(), preview = true){
    let modalId = 'AuthorizationPreviewComponent_'+Math.random();
    const dialogRef2 = this.dialog.open(AuthorizationPreviewComponent, 
    {   disableClose : true,
        id:modalId,
        data: {owner: this.gs.getCompanieSel(), modalId:modalId, authorization:this.data.authorization, authorizeData:authorizeData , preview: preview}
    });
  }


  selectBusiness(item, authorization = false){

    this.businessSelected = item?.company_person_id || item;
    this.businessSelectedData = item;

    this.formGroup.reset();
    
    if(this.businessSelected == 0 && !this.data?.authorization){
        this.setControlValue('type', '2');
        this.setControlValue('creci_state_id', this.personData?.creci_state_id || '1');
        //this.getFormControl('creci_state_id').setValidators([Validators.required]);
        this.getFormControl('document').setValidators([Validators.required, Validators.minLength(14), Document.validate('cnpj')]);
        this.addressSelected = new Address();
        this.readonly = false;
        this.documentReadonly = false;
        this.addressReadonly = false;
        this.enableEdit(true);
        //this.formGroup.markAsPristine();
        return;
    }

    if(authorization && this.data?.authorization?.ad_commission){
      let currencyCustom = new CurrencyCustomPipe();
      this.comissionSel = currencyCustom.transform(this.data?.authorization?.ad_commission || '5.0000', false, 'pt');
    }    

    if(authorization || this.businessSelected){
      this.formDisabled=true;
      this.addressReadonly = true;
    }
    
    let mask = new MaskPipe(this.ms);
    let person_type = (item?.person_type || item?.type);
    let document = mask.transform(item?.document || '', person_type=='1'? '999.999.999-99' : '99.999.999/9999-99');
    this.getFormControl('document').setValidators([Validators.required, Document.validate(person_type=='1'? 'cpf': 'cnpj')]);

    this.setControlValue('person_id', item.company_person_id);
    this.setControlValue('type', person_type);
    this.setControlValue('name', item?.name || item?.company_name);
    this.setControlValue('document', document);
    this.setControlValue('creci', item?.creci_code || item?.creci);
    this.setControlValue('creci_state_id', item.creci_state_id);   

    if(this.data?.authorization){
      this.setControlValue('address', item?.address || '');
      this.setControlValue('expiration', this.expirationSel);
      this.setControlValue('comission', this.comissionSel);
    }
    this.addressSelected = {...item?.address,...{}};

    this.readonly = true;
    this.formGroup.markAllAsTouched();

    let enableEdit = [];
    if(!document)
      enableEdit = ['document'];

    this.enableEdit(!this.formDisabled,[...['expiration','comission'],...enableEdit]);

    if(item.type=='1' && !this.data?.authorization){
        this.documentReadonly = false;
        this.addressReadonly = false;
    } else {
        this.documentReadonly = true;
        this.addressReadonly = true;
    }
    //this.formGroup.markAsPristine();
  }

  async action(event, action){
    this.buttonsDisabled=true;

    switch(action){
      case 'reject':
        this.authorizationService.reject(this.data, (result)=>{
          this.buttonsDisabled=false;
          if(result)
            this.closeModal(result);
        });

      break;
      case 'authorize':
        
        let data = this.getFormValues();

        this.authorizationService.authorize(this.contentEl, this.data.authorization, data, (err=null)=>{

          this.buttonsDisabled=false;
          if(!err){
            this.previewAuthorization(null, data, false);
            this.closeModal();
          }
        });
      break;
    }
  }

  async request(event){
    this.sended = true;
    let data:any = this.getFormValues();
        data.document = data.document.replace(/[^0-9]+/g, "");
    
    let address = this.addressForm?.updateObjectAddress() || {};
    data = {...data,...address};
    let newAddress = this.addressForm.updateObject(true);
    let updateDocument = this.businessSelectedData?.type=='1' && this.businessSelectedData.document != data.document;
    let updateAddress = this.businessSelectedData?.type=='1' && (!(this.businessSelectedData.address instanceof Address) || !this.businessSelectedData.address.compareTo(newAddress));
    
    
    if(updateDocument || updateAddress){
        let dataUpdate:any = {};
        if(updateDocument)
            dataUpdate.document = data.document;

        if(updateAddress)
            dataUpdate.address = address;
    
        await this.updateProfileData(dataUpdate);
    }

    await this.sendAuthorizationRequest(data); 

  }

  async updateProfileData(data){
        
    await this.als.setLoaded(false, 'updateProfileData');
    return await this.httpService.put<any>(API.profile.general.base, data)
          .then(result => {
            this.gs.error({}, 'Dados do seu perfil atualizados');
            this.gs.doConfirmSignedIn(false);
          })
          .catch((err) => this.gs.error(err))
          .finally(async () => {
            await this.als.setLoaded(true, 'updateProfileData');
        });
  } 

  
  async sendAuthorizationRequest(data){
    let nd = {
        ... (this.data?.adId? {ad_id : this.data.adId} : {}),
        ad_owner_public_idtext : this.data?.owner?.publicIdText || this.data?.public_idtext || null,
        payload : data,
        owner_person_id : data.person_id
    };

    await this.als.setLoaded(false, 'requestSaleAuthorization');
    return await this.httpService.post<any>(API.person.general.authorization.request, nd)
          .then(result => {
            this.gs.error({}, 'Solicitação enviada com sucesso');
            this.gs.transactionData.next({method:'request',action:'reload'});
            this.closeModal();
          })
          .catch((err) => {
              console.log(err);
              this.gs.error(err);
          })
          .finally(async () => {
            await this.als.setLoaded(true, 'requestSaleAuthorization');
            this.sended = false;
        });
}


  resolveCPF(event){
    let modalId = 'ReasonComponent_'+Math.random();
    const dialogRef = this.dialog.open(ReasonComponent, 
    {   disableClose : true,
        id:modalId,
        data: {
          modalId:modalId,
          title : 'Informe seu CPF',
          placeholder: 'CPF',
          mask: '000.000.000-00',
          max:14,
          validators : [Validators.required, Document.validate('cpf')]
        }
    });
    dialogRef.afterClosed().subscribe(async result => {
      if(result?.reason){
        this.als.setLoaded(true, 'documentProfile');
        await this.httpService.put<any>(API.profile.general.base, {document: result.reason})
          .then(result => {
            this.gs.error({}, 'Documento salvo');
            this.gs.doConfirmSignedIn(false);
          })
          .catch((err) => this.gs.error(err))
          .finally(() => {
            this.als.setLoaded(true, 'documentProfile');
        });
      }
    });
  }
  resolveSignature(event){

    let modalId = 'SignaturePadComponent_'+Math.random();
    const dialogRef = this.dialog.open(SignaturePadComponent, 
    {   disableClose : true,
        id:modalId,
        data: {
          modalId:modalId,
          person_id:this.personData?.person_id,
          file_id:this.personData?.signature_file_id,
        }
    });   
  }

  openRequests(id){
    this.gs.navigate(['openModal', 'DialogRequestListComponent', id]);
  }

  openAuthorizations(id){
    this.gs.navigate(['openModal', 'DialogAuthorizationListComponent', id]);
  }

  imageError(ev, data){
    data.avatarError = true;
  }


}